<template lang="html">
  <div id="userinfo">
    <h1>ユーザー情報</h1>
    <table id="user_information" border="1">
      <tbody>
        <tr>
          <td class="cate1">
            名前
          </td>
          <td>
            :
          </td>
          <td>
            {{$store.state.userInfo.fullname}}（{{ userType }}）
          </td>
        </tr>
        <tr>
          <td class="cate1">ユーザー名(ID)</td>
          <td>
            :
          </td>
          <td>{{$store.state.userInfo.user_name}}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="$store.state.userInfo.user_type !== 'viewer'">
      <password-change-panel :user_id="$store.state.userInfo.user_id"></password-change-panel>
      <user-name-change-panel :user_id="$store.state.userInfo.user_id" :current_user_name="$store.state.userInfo.user_name"  @changed="getUserInfo()"></user-name-change-panel>
      <mail-address-change-panel :user_id="$store.state.userInfo.user_id" :current_mail="$store.state.userInfo.mail_address"></mail-address-change-panel>
      <status-change-panel :user_id="$store.state.userInfo.user_id" :current_status="$store.state.userInfo.status"></status-change-panel>
    </div>
    <button type="button" name="button" @click='getinformation' class="square_btn1">OK</button>
  </div>
</template>

<script>
import PCPanel from './PasswordChangePanel'
import UCPanel from './UserNameChangePanel'
import MCPanel from './MailAddressChangePanel'
import SCPanel from './StatusChangePanel'
import { mapActions } from 'vuex'
export default {
  components: {
    'password-change-panel': PCPanel,
    'user-name-change-panel': UCPanel,
    'mail-address-change-panel': MCPanel,
    'status-change-panel': SCPanel
  },
  computed: {
    userType () {
      switch (this.$store.state.userInfo.user_type) {
        case 'admin':
          return '管理者'
        case 'teacher':
          return '教師'
        case 'student':
          return '生徒'
        case 'viewer':
          return '閲覧者'
      }
    }
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'getInformation'
    ]),
    getinformation () {
      this.getInformation().then((res) => {
        console.log(this.$store.state.information)
      })
    }
  },
  created () {
    this.getUserInfo().then((res) => {
      console.log('UserInfo')
      console.log(this.$store.state.userInfo)
    })
  }
}
</script>

<style lang="css" scoped>
table {
  width: 42%;
  margin: auto;
  border-style: none;
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 14px;
  color: #5B5B5B;
}
td {
  border-style: none;  
}
th {
  border-style: none;
}
h1 {
  padding: 0.5em;
  background: aliceblue;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.23);
  width: 600px;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 18px;
}
.cate1 {
  width: 35%;
}

.square_btn1{
    display: inline-block;
    padding: 7px 20px;
	  border-radius: 25px;
    text-decoration: none;
    color: #FFF;
    background-image: -webkit-linear-gradient(45deg, #D0D0D0 0%, #808080 100%);
    background-image: linear-gradient(45deg, #D0D0D0 0%, #808080 100%);
    transition: .4s;
    margin-top: 50px;
}

.square_btn1:hover {
    background-image: -webkit-linear-gradient(45deg, #D0D0D0 0%, #808080 100%);
    background-image: linear-gradient(45deg, #D0D0D0 0%, #808080 100%);
}


</style>



// WEBPACK FOOTER //
// UserInfoPage.vue?15404110